export enum CourseParticipantExpenseStatus {
  Draft = "draft",
  Validated = "validated",
  Rejected = "rejected",
  OrderCreated = "ordercreated",
}
